import React from "react"
import { Helmet } from "react-helmet"

const Pixel = () => {
  return (
    <Helmet>
      <script type="text/javascript" id="linkedin-pixel-script1">
        {`
          _linkedin_partner_id = "7051220";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        `}
      </script>
      <script type="text/javascript" id="linkedin-pixel-script2">
        {`!
          (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);})(window.lintrk);
        `}
      </script>
      <noscript id="linkedin-pixel-image">
        {`<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=7051220&fmt=gif" />`}
      </noscript>
      <script key="function" id="facebook-pixel-script">
        {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '4105506549683015');
          fbq('track', 'PageView');
        `}
      </script>
      <noscript key="image" id="facebook-pixel-image">
        {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=4105506549683015&ev=PageView&noscript=1"/>`}
      </noscript>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-11106763338"
      ></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11106763338');
        `}
      </script>
    </Helmet>
  )
}

export default Pixel
